import React, { useEffect, useState, useMemo } from "react";
import { collection, onSnapshot, doc, getDoc, query, orderBy  } from "firebase/firestore";
import { db } from "../Config/Firebase";

const WalletList = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");

  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 35;

  useEffect(() => {
    setLoading(true);

    // 👇 Fetch data order by date
    const q = query(
      collection(db, "walletLogs"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      async (paymentSnapshot) => {
        try {
          const paymentsWithUser = await Promise.all(
            paymentSnapshot.docs.map(async (docSnap) => {
              const paymentData = docSnap.data();
                let userData = {};
              //Fetch Users Dta
              if(!paymentData.userId ){  
              const userRef = doc(db, "users", paymentData.user_id);
              const userSnap = await getDoc(userRef);
              userData = userSnap.exists() ? userSnap.data() : {};
              }else{
                const userRef = doc(db, "users", paymentData.userId);
                const userSnap = await getDoc(userRef);
                userData = userSnap.exists() ? userSnap.data() : {};
              }

              return {
                id: docSnap.id,
                amount: paymentData.amount,
                fromAmount: paymentData.amountBefore || paymentData.fromAmount,
                toAmount: paymentData.amountAfter || paymentData.toAmount,
                type: paymentData.transactionType || paymentData.type,
                
                createdAt: paymentData.createdAt, 
                userName: userData.name || "Unknown User",
                userEmail: userData.email || "",
                mobile: userData.mobile || "",
                profileImageUrl: userData.profileImageUrl || "",
                reason: paymentData.reason || paymentData.type || "N/A",
              };
            })
          );

          setPayments(paymentsWithUser);
          setError("");
        } catch (err) {
          console.error(err);
          setError("Failed to load payments");
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error(err);
        setError("Failed to listen to payments");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // Filtering 
  const filteredPayments = useMemo(() => {
    const today = new Date();

    let filtered = payments.filter((payment) => {
      const nameMatch = payment.userName
        ?.toLowerCase()
        .includes(search.toLowerCase());
      const typeMatch = payment.type
        ?.toLowerCase()
        .includes(search.toLowerCase());
      const mobileMatch = payment.mobile
        ?.toLowerCase()
        .includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        let createdDate;

        
        if (typeof payment.createdAt === "number") {
          createdDate = new Date(payment.createdAt); 
        } else if (payment.createdAt?.seconds) {
          createdDate = new Date(payment.createdAt.seconds * 1000); 
        } else if (typeof payment.createdAt === "string") {
          createdDate = new Date(payment.createdAt);
        }

        if (createdDate && !isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);

        } else {
          matchesDate = false;
        }
      }

      return (nameMatch || typeMatch || mobileMatch) && matchesDate;
    });

    if (sortOption === "name-asc") {
      filtered.sort((a, b) => (a.userName || "").localeCompare(b.userName || ""));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => (b.userName || "").localeCompare(a.userName || ""));
    } else if (sortOption === "date-asc") {
      filtered.sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
        return dateA - dateB;
      });
    } else if (sortOption === "date-desc") {
      filtered.sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
        return dateB - dateA;
      });
    } else if (sortOption === "Credit") {
      filtered.sort((a, b) => {
        const creditA = a.type === "CREDIT" ? a.amount : 0;
        const creditB = b.type === "CREDIT" ? b.amount : 0;
        return creditB - creditA;
      });
    } else if (sortOption === "Debit") {
      filtered.sort((a, b) => {
        const debitA = a.type === "DEBIT" ? a.amount : 0;
        const debitB = b.type === "DEBIT" ? b.amount : 0;
        return debitB - debitA;
      });
    }

    return filtered;
  }, [payments, search, daysFilter, sortOption]);

  // Pagination logic
  const totalPages = Math.ceil(filteredPayments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPayments = filteredPayments.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="Fee-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Wallet Log List</h2>

      {/* Filters */}
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by name, email, or mobile..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />

        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
          <option value="Credit">Highest Credit</option>
          <option value="Debit">Highest Debit</option>

        </select>
      </div>

      {/* Table */}
      <table className="w-full text-sm border wallet-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="usertable-td text-left">#</th>
            <th className="usertable-td text-left">Name</th>
            <th className="usertable-td text-left">Amount</th>
            <th className="usertable-td text-left">Before Account Balance</th>
            <th className="usertable-td text-left">Account Balance</th>
            <th className="usertable-td text-left">Type</th>
            <th className="usertable-td text-left">Date</th>
          </tr>
        </thead>

        <tbody>
          {currentPayments.length > 0 ? (
            currentPayments.map((payment, index) => (
              <tr key={payment.id} className="border-t">
                <td className="usertable-td">{startIndex + index + 1}</td>
                <td className="usertable-td flex flex-wrap items-center gap-3">
                  <img
                    src={payment.profileImageUrl || "N/A"}
                    alt="avatar"
                    className="w-10 h-10 rounded-full"
                  />
                  <span>{payment.userName}</span>
                </td>
                <td
                  className={`usertable-td ${
                    payment.type === "DEBIT" || payment.type === "TEXT_CHAT_DEDUCTION" ? "text-red-500"  : "text-green-500"
                  }`}
                >
                   {payment.type === "DEBIT" || payment.type === "TEXT_CHAT_DEDUCTION" 
                    ? `- ${payment.amount}`
                    : `+ ${payment.amount}`}
                </td>
                <td className="usertable-td"> {payment.fromAmount}</td>
                <td className="usertable-td"> {payment.toAmount}</td>
                <td className="usertable-td">{payment.reason}</td>
                <td className="usertable-td">
                  {formatDateTime(payment.createdAt)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default WalletList;

// Format Date - time
const formatDateTime = (value) => {
  if (!value) return "";

  let date;
  if (typeof value === "number") {
    date = new Date(value);
  } else if (value?.seconds) {
    date = new Date(value.seconds * 1000);
  } else if (typeof value === "string") {
    date = new Date(value);
  } else {
    return "";
  }

  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};



